import { render, staticRenderFns } from "./ArticleCreate.vue?vue&type=template&id=4b3f9aa3"
import script from "./ArticleCreate.vue?vue&type=script&lang=js"
export * from "./ArticleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports